module.exports = __webpack_public_path__ + "img/icon-company.1b714f02.png";